import React from 'react';

const EmptyMerchantLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d_1958_33111)">
      <circle cx="16" cy="14" r="14" fill="white" />
    </g>
    <rect x="3.61523" y="1.61523" width="24.7692" height="24.7692" rx="12.3846" fill="white" />
    <path d="M23.5447 11.1367L22.4677 7.90595C22.4303 7.7945 22.3574 7.69837 22.2601 7.63226C22.1629 7.56614 22.0467 7.53367 21.9293 7.53979H10.0831C9.9657 7.53367 9.8495 7.56614 9.75227 7.63226C9.65504 7.69837 9.58212 7.7945 9.54466 7.90595L8.46773 11.1367C8.45997 11.1939 8.45997 11.2519 8.46773 11.309V14.5398C8.46773 14.6826 8.52446 14.8196 8.62544 14.9205C8.72643 15.0215 8.86339 15.0783 9.00619 15.0783H9.54466V20.4629H10.6216V15.0783H13.8523V20.4629H22.4677V15.0783H23.0062C23.149 15.0783 23.286 15.0215 23.3869 14.9205C23.4879 14.8196 23.5447 14.6826 23.5447 14.5398V11.309C23.5524 11.2519 23.5524 11.1939 23.5447 11.1367ZM21.3908 19.3859H14.9293V15.0783H21.3908V19.3859ZM22.4677 14.0013H20.3139V11.8475H19.237V14.0013H16.5447V11.8475H15.4677V14.0013H12.7754V11.8475H11.6985V14.0013H9.54466V11.3952L10.4708 8.61672H21.5416L22.4677 11.3952V14.0013Z" fill="black" />
    <defs>
      <filter id="filter0_d_1958_33111" x="0" y="0" width="32" height="32" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feColorMatrix type="matrix" values="0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0 0.141176 0 0 0 0.102 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1958_33111" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1958_33111" result="shape" />
      </filter>
    </defs>
  </svg>

);
export default EmptyMerchantLogo;
